export const SearchRespostas = (props) => {
  return (
    <>
      <div>
        <span className="col-form-label">Código Resposta</span>
        <div>
          <input
            type="text"
            className="form-control form-control-sm border border-dark"
            value={props.dataFiltro?.id || ''}
            onChange={(e) =>
              props.setDataFiltro({
                ...props.dataFiltro,
                id: e.target.value
              })
            }
          />
        </div>
      </div>

      <div>
        <span className="col-form-label">Descrição Resposta</span>
        <div>
          <input
            type="text"
            className="form-control form-control-sm border border-dark"
            value={props.dataFiltro?.descricao || ''}
            onChange={(e) =>
              props.setDataFiltro({
                ...props.dataFiltro,
                descricao: e.target.value.toUpperCase()
              })
            }
            style={{ textTransform: 'uppercase' }}
          />
        </div>
      </div>

      <div>
        <span className="col-form-label">Tipo Resposta</span>
        <div>
          <select
            className="form-select form-select-sm border border-dark"
            value={props.dataFiltro?.tipoResposta || ''}
            onChange={(e) =>
              props.setDataFiltro({
                ...props.dataFiltro,
                tipoResposta: e.target.value
              })
            }
          >
            <option defaultValue></option>
            <option value="OBJET">OBJETIVA</option>
            <option value="SUBJE">SUBJETIVA</option>
          </select>
        </div>
      </div>

      <div>
        <span className="col-form-label">Tipo Resposta Subjetiva</span>
        <div>
          <select
            className="form-select form-select-sm border border-dark"
            value={props.dataFiltro?.tipoRespostaSub || ''}
            onChange={(e) =>
              props.setDataFiltro({
                ...props.dataFiltro,
                tipoRespostaSub: e.target.value
              })
            }
          >
            <option defaultValue></option>
            <option value="RSBST">ALFA NUMÉRICA</option>
            <option value="RSBNU">NUMÉRICA</option>
          </select>
        </div>
      </div>

      {/* button */}
      <div className="row mt-2">
        <div className="col-12 d-flex align-items-center justify-content-end">
          <button
            className="btn btn-primary"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => props.setFilter(props.filter + 1)}
          >
            <i className="fa-solid fa-magnifying-glass"></i>
          </button>
        </div>
      </div>
    </>
  );
};
